import { render, staticRenderFns } from "./FairPayComingSoonPage.vue?vue&type=template&id=26c2d88f&scoped=true"
import script from "./FairPayComingSoonPage.vue?vue&type=script&lang=js"
export * from "./FairPayComingSoonPage.vue?vue&type=script&lang=js"
import style0 from "./FairPayComingSoonPage.vue?vue&type=style&index=0&id=26c2d88f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c2d88f",
  null
  
)

export default component.exports